import React, {useEffect, useState, useMemo} from "react";
import {useDispatch, useSelector} from "react-redux";
import styles from "./styles.module.scss";
import {MdEdit} from "react-icons/md";
import {
    Table,
    TextInput,
    Button
} from "components";
import {communicationChannelAction} from "redux/actions";
import {useHistory, useLocation} from "react-router-dom";
import * as XLSX from "xlsx";
import {adminTokenDev} from "../../../helper";
import axios from "axios";
import {DEV_APIS_URL} from "../../../configurations";
import AddRelationshipType from "./AddCommChannel";
import UpdateRelationshipType from "./UpdateCommChannel";

export default function CommChannelPanel() {

    // States
    const [tableRows, setTableRows] = useState();

    // Filter States
    const [status, setStatus] = useState();
    const [filtername, setFiltername] = useState('');
    const [filterdesc, setFilterdesc] = useState('');
    const [editableDetails, setEditableDetails] = useState({});
    const [updateStatus, setUpdateStatus] = useState(false);
    const [datarefresh, setDatarefresh] = useState(false);

    // Redux actions
    const dispatch = useDispatch();
    const {customers, communicationchannel, userRole} = useSelector(state => ({
        customers: state.customers,
        communicationchannel: state.communicationChannel,
        userRole: state.userRole?.filter(role => role.module === "Communication Channels")
    }));

    useEffect(() => {
        if (userRole?.find(item => item.privilege === "Read"))
            dispatch(communicationChannelAction.get());        
        return () => dispatch(communicationChannelAction.reset());
    }, [updateStatus,datarefresh]);

    useEffect(() => {
        if (!communicationchannel?.length) {
            setTableRows();
            return;
        }

        let filtered = communicationchannel;
        // if (filtername) {
        //     filtered = filtered?.filter(data => data.relationship_name.toLowerCase() == filtername.toLowerCase());
        // }

        // if (filterdesc) {
        //     filtered = filtered?.filter(data => data.description.toLowerCase() == filterdesc.toLowerCase());
        // }

        let newData = [];
       
        // Map table rows
        filtered?.forEach(obj => {
            const data = {
                userId: obj?.id,
                channel_name: obj?.channel_name,
                edit: (
                        <MdEdit
                            size="20"
                            color="#528ff0"
                            onClick={
                                () => {
                                    setEditableDetails(obj);
                                    setUpdateStatus(true);
                                }
                            }
                            className="clickable"
                        />
                    ),
                action: (
                    <Button
                        title={'Delete'}
                        style={{"padding":"0 0", "width": "55px"}}
                        onClick={
                            () => {
                                if (window.confirm("Are you sure you want to delete this item?")) {
                                    dispatch(communicationChannelAction.deletedata({ id: obj?.id}));
                                    setDatarefresh(Math.random());
                                }
                            }
                        }
                    />
                )
            };
            newData.push(data);
        });

        setTableRows(newData);
    }, [communicationchannel,filtername, status, filterdesc]);

    
    const setCreateStatus = () => {
        setUpdateStatus(false);
    }

    // Table Header
    const tableHeaders = useMemo(
        () => [
            {
                title: "Si.No",
                sortBy: "userId"
            },
            {
                title: "Channel Name",
                sortBy: "channel_name"
            },
            {
                title: "Edit"
            },
            {
                title: "Delete"
            }
        ],
        [tableRows]
    );
    //v2-app
    const exportDataFunc = () => {
        adminTokenDev()
            .then(token =>
                axios.get(
                    `${DEV_APIS_URL}/communication-channels`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                ).then((response) => {
                        const rows = response.data.map(item => {
                            return {
                                "Id": item.id,
                                "Channel Name": item.channel_name,
                                "Created At": item.created_at,
                                "Updated At": item.updated_at
                            }
                        })

                        const worksheet = XLSX.utils.json_to_sheet(rows);
                        const workbook = XLSX.utils.book_new();
                        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
                        XLSX.writeFile(workbook, "communication-channels-Datas.xlsx");
                    }
                )
            )
    }

    return (
        <div>
            <div className="row">
                <div className="col-sm-6">
                    <div className={styles.filter}>
                        {/* <TextInput
                            label=""
                            placeholder="Filter By Name"
                            name="search"
                            onChange={e => setFiltername(e.target.value)}
                            value={filtername}
                        />
        
                        <TextInput
                            label=""
                            placeholder="Filter By Description"
                            name="search"
                            onChange={e => setFilterdesc(e.target.value)}
                            value={filterdesc}
                        /> */}
                        
                        <button className={'btn btn-primary'} style={{marginTop: 10}}
                                onClick={exportDataFunc}
                        >Export
                        </button>
                    </div>

                    <Table
                        headers={tableHeaders}
                        data={tableRows}
                        current={communicationchannel?.pageNumber}
                        totalPage={Math.ceil(communicationchannel?.count / 10)}
                        state={communicationchannel}
                        length={tableRows?.length}
                        r_length={communicationchannel?.users?.length}
                        t_length={communicationchannel?.count}
                        exportData={false}
                    />
                    
                </div>
                <div className="col-sm-6" style={{marginTop: "66px", paddingLeft: "35px", borderLeft: "1px solid #44444466"}}>
                    {(updateStatus === true)?<UpdateRelationshipType editableDetails={editableDetails} onUpdate={setCreateStatus}/>:<AddRelationshipType status={setStatus} />}
                </div>
            </div>
        </div>
    );
}
